import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { useNavigate, useParams } from "react-router-dom";
import { updateUsers, editUsers } from "../../../apis/profileInfoApi";
import { profileSchema } from "../../../Validations/profileValidation";
export default function ProfileInformation() {
  const [loading, setLoading] = useState(false);
  // const [message, setMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);

  // const { id } = useParams();
  const navigate = useNavigate();

  const currentUserId = localStorage.getItem("Id") || null;
  // console.log({ currentUserId: currentUserId });
  const [profileInitial, setProfileInitial] = useState({
    name: "",
    email: "",
    address: "",
    address2: "",
    address3: "",
    phoneNumber: "",
    country: "",
  });

  useEffect(() => {
    if (currentUserId) {
      editProfileInformation(currentUserId);
    }
  }, [currentUserId]);

  const editProfileInformation = async (userId) => {
    if (!userId) {
      console.error("No user ID provided");
      return;
    }
    setDataLoader(true);
    try {
      console.log("1");
      const res = await editUsers(userId);
      console.log({ res123456789prodile: res });
      console.log("2");
      console.log({ res123456789prodile: res });
      if (res.result) {
        const userData = res.result;
        console.log({ userData1234: userData });
        setDataLoader(false);
        setProfileInitial({
          name: `${userData.firstName || ""} ${userData.surName || ""}`.trim(),
          email: userData.email || "",
          phoneNumber: userData.phoneNumber || "",
          address: userData.address1 || "",
          address2: userData.address2 || "",
          address3: userData.address3 || "",
          country: userData.country || "",
        });
      } else {
        setDataLoader(false);
        console.log("No user data received");
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching user details:", error);
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: profileInitial,
    enableReinitialize: true,
    validationSchema: profileSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        let res;
        if (currentUserId) {
          res = await updateUsers({
            userId: currentUserId,
            ...values,
          });
          if (res.success) {
            // navigate("/Notifications");
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
  });
  const backClick = () => {
    navigate("/Notifications");
  };

  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <i
              className="fas fa-arrow-left"
              style={{ marginRight: "30px", fontSize: "20px" }}
              onClick={backClick}
            />
            <div className="my-3 p-3 bg-body rounded shadow-sm">
              {dataLoader ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "50px", padding: "7px 30px" }}
                >
                  <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={formik.handleSubmit}>
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="name"
                              value={formik.values.name}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.errors.name && formik.touched.name ? (
                              <span className="text-danger">
                                {formik.errors.name}
                              </span>
                            ) : null}
                          </div>
                        </div>
                        {/* <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label">First Name</label>
                            <input
                              type="text"
                              className="form-control"
                              name="firstName"
                              value={formik.values.firstName}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.errors.firstName &&
                            formik.touched.firstName ? (
                              <span className="text-danger">
                                {formik.errors.firstName}
                              </span>
                            ) : null}
                          </div>
                        </div> */}
                        <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Email</label>
                            <input
                              type="email"
                              className="form-control"
                              name="email"
                              value={formik.values.email}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.errors.email && formik.touched.email ? (
                              <span className="text-danger">
                                {formik.errors.email}
                              </span>
                            ) : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label">Country</label>
                            <input
                              type="text"
                              className="form-control"
                              name="country"
                              value={formik.values.country}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.errors.country && formik.touched.country ? (
                              <span className="text-danger">
                                {formik.errors.country}
                              </span>
                            ) : null}
                          </div>
                        </div>
                        {/* <div className="col-md-6">
                          <div className="input-block mb-3">
                            <label className="col-form-label">
                              Date Of Birth
                            </label>
                            <input
                              type="date"
                              name="birthDate"
                              className="form-control"
                              value={formik.values.birthDate}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            />
                            {formik.errors.birthDate &&
                            formik.touched.birthDate ? (
                              <span className="text-danger">
                                {formik.errors.birthDate}
                              </span>
                            ) : null}
                          </div>
                        </div> */}
                        {/* <div className="col-md-6">
                          <div className="input-block mb-3">
                            <div className="d-flex justify-content-between">
                              <label className="col-form-label">Password</label>
                              <i
                                className="fa fa-pencil m-r-5 mt-1"
                                onClick={() => setShowPassword(!showPassword)}
                              ></i>
                            </div>
                            {!showPassword && (
                              <input
                                type="text"
                                className="form-control"
                                name=""
                                value="********"
                              />
                            )}
                            {showPassword && (
                              <input
                                type="text"
                                className="form-control"
                                name="password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              />
                            )}
                            {formik.errors.password &&
                            formik.touched.password ? (
                              <span className="text-danger">
                                {formik.errors.password}
                              </span>
                            ) : null}
                          </div>
                        </div> */}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Address 1</label>
                        <input
                          type="text"
                          name="address"
                          className="form-control"
                          value={formik.values.address}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.address && formik.touched.address ? (
                          <span className="text-danger">
                            {formik.errors.address}
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Address 2</label>
                        <input
                          type="text"
                          name="address2"
                          className="form-control"
                          onChange={formik.handleChange}
                          value={formik.values.address2}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.address2 && formik.touched.address2 ? (
                          <span className="text-danger">
                            {formik.errors.address2}
                          </span>
                        ) : null}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Address 3</label>
                        <input
                          type="text"
                          name="address3"
                          className="form-control"
                          onChange={formik.handleChange}
                          value={formik.values.address3}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.address3 && formik.touched.address3 ? (
                          <span className="text-danger">
                            {formik.errors.address3}
                          </span>
                        ) : null}
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Country</label>
                        <input
                          type="text"
                          className="form-control"
                          name="country"
                          onChange={formik.handleChange}
                          value={formik.values.country}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.country && formik.touched.country ? (
                          <span className="text-danger">
                            {formik.errors.country}
                          </span>
                        ) : null}
                      </div>
                    </div> */}
                    <div className="col-md-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Mobile</label>
                        <input
                          type="text"
                          className="form-control"
                          name="phoneNumber"
                          value={formik.values.phoneNumber}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        />
                        {formik.errors.phoneNumber &&
                        formik.touched.phoneNumber ? (
                          <span className="text-danger">
                            {formik.errors.phoneNumber}
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </div>
                  {loading ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "50px", padding: "7px 30px" }}
                    >
                      <div className="spinner-border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <button className="btn btn-primary " type="submit">
                        Update
                      </button>
                    </div>
                  )}
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
